export const Loading = () => {
  return (
    <div className="w-full border text-blue-dark bg-yellow p-3 mt-5 rounded-full text-center text-gray font-bold text-xl">
      CARREGANDO...
    </div>
  );
};
